import React from "react";
import {
  Button,
  ButtonProps,
  Link as ChakraLink,
  Tooltip,
} from "@chakra-ui/react";
import { BsArrowUpRight, BsLockFill } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { RecruitmentSeasonConfig } from "../types";

interface Props extends Omit<ButtonProps, "variant"> {
  config: RecruitmentSeasonConfig;
  variantType?: "hero" | "section" | "drawer";
  departmentName?: string;
}

export const RecruitmentCTAButton: React.FC<Props> = ({
  config,
  variantType = "hero",
  departmentName,
  ...chakraButtonProps
}) => {
  const isClosed = config.status === "CLOSED";

  // When applications are OPEN
  if (!isClosed) {
    let label = "Nộp đơn ngay";
    if (variantType === "drawer" && departmentName) {
      label = `Nộp Đơn Ứng Tuyển (${departmentName})`;
    } else if (variantType === "section") {
      label = "Nộp đơn ứng tuyển ngay";
    }

    return (
      <ChakraLink
        href={config.formUrl}
        isExternal
        _hover={{ textDecoration: "none" }}
      >
        <Button
          rightIcon={<BsArrowUpRight />}
          {...chakraButtonProps}
        >
          {label}
        </Button>
      </ChakraLink>
    );
  }

  // When applications are CLOSED
  if (variantType === "drawer") {
    return (
      <Tooltip
        label="Cổng đăng ký Gen 8 đã chính thức đóng. Vui lòng theo dõi Fanpage để cập nhật các đợt tuyển tiếp theo."
        placement="top"
        hasArrow
      >
        <Button
          isDisabled
          cursor="not-allowed"
          opacity={0.65}
          backgroundColor="gray.400"
          color="white"
          _hover={{ backgroundColor: "gray.400" }}
          leftIcon={<BsLockFill />}
          {...chakraButtonProps}
        >
          Đã Đóng Đơn Ứng Tuyển {departmentName ? `(${departmentName})` : ""}
        </Button>
      </Tooltip>
    );
  }

  if (variantType === "section") {
    return (
      <ChakraLink
        href={config.fanpageUrl}
        isExternal
        _hover={{ textDecoration: "none" }}
      >
        <Button
          height="60px"
          px={10}
          borderRadius="0"
          backgroundColor="white"
          color="#1c1b20"
          fontSize="sm"
          fontWeight="800"
          letterSpacing="0.08em"
          textTransform="uppercase"
          leftIcon={<FaFacebookF />}
          rightIcon={<BsArrowUpRight size={18} />}
          _hover={{
            backgroundColor: "#f0f0f0",
            transform: "translateY(-2px)",
          }}
          transition="all 0.2s"
          {...chakraButtonProps}
        >
          Theo dõi kết quả tại Fanpage
        </Button>
      </ChakraLink>
    );
  }

  // variantType === "hero"
  return (
    <ChakraLink
      href={config.fanpageUrl}
      isExternal
      _hover={{ textDecoration: "none" }}
    >
      <Button
        height="50px"
        px={8}
        borderRadius="0"
        backgroundColor="white"
        color="#1c1b20"
        fontWeight="700"
        fontSize="sm"
        letterSpacing="0.08em"
        textTransform="uppercase"
        leftIcon={<FaFacebookF />}
        rightIcon={<BsArrowUpRight />}
        _hover={{
          backgroundColor: "#f0f0f0",
          transform: "translateY(-2px)",
        }}
        transition="all 0.2s"
        {...chakraButtonProps}
      >
        Xem thông báo tại Fanpage
      </Button>
    </ChakraLink>
  );
};
